// extracted by mini-css-extract-plugin
export default {"bgColor":"bookmarks_bgColor__CoVDM","seeCard":"bookmarks_seeCard__WuQOI","titleClass":"bookmarks_titleClass__k6jto","p":"bookmarks_p__TJD1y","myImage":"bookmarks_myImage__mG-dv"};